/*! header-submenu-horizontal
    Keeps the horizontal header dropdowns inside the viewport.

    A row of links is much wider than a stacked list, so a dropdown opened from a
    menu item near the right edge would otherwise overflow the page. Loaded by
    sections/submenu-layout.liquid only when the layout is set to Horizontal.
*/

(function () {
  var SELECTOR = '.header details[level="top"] > .dropdown';
  var LINK_SELECTOR = '.header details[level="top"] > .dropdown .dropdown__nav a';
  var EDGE_PADDING = 16;

  /* The "All …" entry opens the brand landing page rather than a collection, so it
     gets its own row and style. Matched on the label so new ones are picked up
     automatically, with no URL hardcoded here. */
  function tagLandingLinks(scope) {
    scope.querySelectorAll(LINK_SELECTOR).forEach(function (link) {
      if (link.classList.contains('submenu-link--all')) return;
      if (link.textContent.trim().toLowerCase().indexOf('all ') !== 0) return;

      link.classList.add('submenu-link--all');

      var item = link.closest('li');
      if (item) item.classList.add('submenu-item--all');
    });
  }

  function position(dropdown) {
    dropdown.style.setProperty('--dropdown-shift', '0px');

    var rect = dropdown.getBoundingClientRect();
    var viewport = document.documentElement.clientWidth;
    var shift = 0;

    if (rect.right > viewport - EDGE_PADDING) {
      shift = -(rect.right - (viewport - EDGE_PADDING));
    }

    if (rect.left + shift < EDGE_PADDING) {
      shift = EDGE_PADDING - rect.left;
    }

    dropdown.style.setProperty('--dropdown-shift', Math.round(shift) + 'px');
  }

  function bind(root) {
    var scope = root && root.querySelectorAll ? root : document;

    tagLandingLinks(scope);

    scope.querySelectorAll(SELECTOR).forEach(function (dropdown) {
      if (dropdown.dataset.submenuPositioned !== 'true') {
        dropdown.dataset.submenuPositioned = 'true';

        var details = dropdown.parentElement;

        ['mouseenter', 'focusin', 'click'].forEach(function (type) {
          details.addEventListener(type, function () {
            position(dropdown);
          });
        });
      }

      position(dropdown);
    });
  }

  function debounce(fn, wait) {
    var timer = null;

    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
    });
  } else {
    bind();
  }

  window.addEventListener('resize', debounce(function () {
    bind();
  }, 150));

  document.addEventListener('shopify:section:load', function () {
    bind();
  });
})();
